import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getCountryFlag } from '../../../util/countries'
import styles from './styles.module.scss'

export default class FlagPicker extends PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className={styles.title}>Choose your language</div>
        <div className={styles.row}>
          <img
            id="selectorFlag-SE"
            src={getCountryFlag('SE')}
            className={styles.flag}
            onClick={() => this.props.onClick('sv')}
          />
          <img
            id="selectorFlag-NO"
            src={getCountryFlag('NO')}
            className={styles.flag}
            onClick={() => this.props.onClick('nb')}
          />
          <img
            id="selectorFlag-DK"
            src={getCountryFlag('DK')}
            className={styles.flag}
            onClick={() => this.props.onClick('da')}
          />
          <img
            id="selectorFlag-FI"
            src={getCountryFlag('FI')}
            className={styles.flag}
            onClick={() => this.props.onClick('fi')}
          />
        </div>
      </React.Fragment>
    )
  }
}

FlagPicker.propTypes = {
  onClick: PropTypes.func.isRequired,
}
